var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},_vm._l((_vm.docs),function(leave){return _c('leave-tile',{key:leave._id,attrs:{"leave":leave}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }